import { Typography } from '@material-ui/core';
import React from 'react';

export const BulletList: React.FC<BulletListProps> = (props: BulletListProps): JSX.Element => {
  let args = '';
  props.listItems.forEach(item => {
    args += `\u2022 ${item}\n`;
  });
  return <Typography data-testid='bullet-list-items'>{args}</Typography>;
};

export interface BulletListProps {
  listItems: string[];
}
